import AccountDetailBanner from './AccountDetailBanner';
import AccountDetailSection from './AccountDetailSection';

function AccountDetail() {
  return (
    <div>
      <AccountDetailBanner />
      <AccountDetailSection />
    </div>
  );
}

export default AccountDetail;